import { createSlice } from "@reduxjs/toolkit";
import { CropFamilyDefaultDataset } from "../data_model/cropFamilyModel/post_crop_family_model";

export const post_Crop_Family = createSlice({
  name: "post_crop_family",
  initialState: {
    value: {
      status: false,
      langMap: CropFamilyDefaultDataset,
      defaultLangMap: CropFamilyDefaultDataset,
    },
  },
  reducers: {
    //create first data item
    resetLangMap: (state, action) => {
      state.value.langMap = CropFamilyDefaultDataset;
    },
    //add empty language dataset
    addNewLangData: (state, action) => {
      state.value.status = true;
      const incomingPayload = action.payload;
      const newArray = [...state.value.langMap.langMap, incomingPayload];
      state.value.langMap.langMap = newArray;
    },
    //update individual items in localization array
    replaceIndex: (state, action) => {
      const newPayload = action.payload;
      const existingPayload = state.value.langMap?.langMap;
      const newUpdateData = existingPayload.map((item) =>
        item.langCode === newPayload.langCode ? newPayload : item
      );
      state.value.langMap.langMap = newUpdateData;
    },
  },
});

export const { resetLangMap, addNewLangData, replaceIndex } =
  post_Crop_Family.actions;

export default post_Crop_Family.reducer;
